import { logger } from "capsule"
import { useEffect, useState } from "react"
import { Platform } from "react-native"
import { check, Permission, PERMISSIONS, request, RESULTS } from "react-native-permissions"

const useLocationPermission = () => {
  const [hasPermission, setHasPermission] = useState<boolean | null>(null)

  const permission: Permission | undefined = Platform.select({
    ios: PERMISSIONS.IOS.LOCATION_WHEN_IN_USE,
    android: PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION,
  })

  const checkPermissionStatus = async () => {
    if (!permission) {
      return setHasPermission(false)
    }
    const result = await check(permission)
    setHasPermission(result === RESULTS.GRANTED)
  }

  const requestLocationPermission = async () => {
    if (!permission) {
      return setHasPermission(false)
    }
    const result = await request(permission)
    setHasPermission(result === RESULTS.GRANTED)
  }

  useEffect(() => {
    if (hasPermission === null) {
      checkPermissionStatus()
    } else if (hasPermission === false) {
      logger("L'utilisateur a refusé la géolocalisation")
    }
    // eslint-disable-next-line
  }, [hasPermission])

  return { hasPermission, requestLocationPermission }
}

export default useLocationPermission
